<template>
    <nav class="m-3" v-show="totalPages > 1" aria-label="Page navigation">
        <ul v-if="totalPages <= 10" class="pagination">
            <li class="page-item" :class="{ 'disabled': currentPage <= 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
            </li>
            <li v-for="aPage in totalPages" :key="aPage" class="page-item" :class="{ 'active': currentPage == aPage }">
                <a class="page-link" href="#" @click.prevent="changePage(aPage)">{{ aPage }}</a>
            </li>
            <li class="page-item" :class="{ 'disabled': currentPage == totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
            </li>
        </ul>
        <ul v-else-if="totalPages > 10" class="pagination">
            <li class="page-item" :class="{ 'disabled': currentPage <= 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
            </li>
            <li v-show="currentPage > 2" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
            </li>
            <li v-show="currentPage > 3" class="page-item disabled">
                <a class="page-link" href="#">&hellip;</a>
            </li>
            <li v-show="currentPage > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">{{ currentPage - 1 }}</a>
            </li>
            <li class="page-item active">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage)">{{ currentPage }}</a>
            </li>
            <li v-show="currentPage + 1 <= totalPages" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">{{ currentPage + 1 }}</a>
            </li>
            <li v-show="currentPage < totalPages - 2" class="page-item disabled">
                <a class="page-link" href="#">&hellip;</a>
            </li>
            <li v-show="currentPage < totalPages - 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(totalPages)">{{ totalPages }}</a>
            </li>
            <li class="page-item" :class="{ 'disabled': currentPage == totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
            </li>
        </ul>
    </nav>
</template>

<script>
  export default {
    name: 'paginator',

    props: ['currentPage', 'totalPages'],

    data () {
      return {
      }
    },

    methods: {
      changePage (newPage) {
        this.$emit('update:currentPage', newPage)
      }
    }
  }
</script>
<style scoped>
</style>
